(function () {
  function init() {
    var product = document.querySelector('[data-pd5-product]');
    if (!product || product.dataset.pd5Ready) return;
    product.dataset.pd5Ready = 'true';
    var detailsArea = product.querySelector('[data-pd5-details]');
    var tablist = detailsArea && detailsArea.querySelector('.pd5-tablist');
    var tabs = tablist ? Array.from(tablist.querySelectorAll('[data-pd5-tab]')) : [];
    var sections = detailsArea ? Array.from(detailsArea.querySelectorAll('[data-pd5-detail]')) : [];
    var mobile = window.matchMedia('(max-width:767px)');
    var reducedMotion = window.matchMedia('(prefers-reduced-motion:reduce)');
    var active = 'description';
    var syncingDetails = false;

    function findSection(id) {
      return sections.find(function (section) { return section.dataset.pd5Detail === id && !section.hidden; });
    }

    function activate(id, focusTab) {
      var selected = findSection(id);
      if (!selected) return;
      active = id;
      syncingDetails = true;
      sections.forEach(function (section) {
        if (!mobile.matches || section === selected) section.open = section === selected;
      });
      tabs.forEach(function (tab) {
        var selectedTab = tab.dataset.pd5Tab === id;
        tab.setAttribute('aria-selected', selectedTab ? 'true' : 'false');
        tab.tabIndex = selectedTab ? 0 : -1;
        if (selectedTab && focusTab) tab.focus();
      });
      syncingDetails = false;
    }

    function applyDetailsMode() {
      if (!detailsArea) return;
      var isMobile = mobile.matches;
      detailsArea.dataset.mode = isMobile ? 'mobile' : 'desktop';
      tablist.hidden = isMobile;
      sections.forEach(function (section) {
        var panel = section.querySelector('.pd5-detail__content');
        var id = section.dataset.pd5Detail;
        panel.setAttribute('role', isMobile ? 'region' : 'tabpanel');
        panel.setAttribute('aria-labelledby', (isMobile ? 'pd5-summary-' : 'pd5-tab-') + id);
        if (isMobile) panel.removeAttribute('tabindex');
        else panel.tabIndex = 0;
      });
      activate(active);
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () { activate(tab.dataset.pd5Tab); });
      tab.addEventListener('keydown', function (event) {
        var available = tabs.filter(function (item) { return !item.hidden; });
        var index = available.indexOf(tab);
        if (event.key === 'ArrowRight') index = (index + 1) % available.length;
        else if (event.key === 'ArrowLeft') index = (index - 1 + available.length) % available.length;
        else if (event.key === 'Home') index = 0;
        else if (event.key === 'End') index = available.length - 1;
        else return;
        event.preventDefault();
        activate(available[index].dataset.pd5Tab, true);
      });
    });

    sections.forEach(function (section) {
      section.addEventListener('toggle', function () {
        if (mobile.matches && section.open && !syncingDetails) active = section.dataset.pd5Detail;
      });
    });

    function jumpToSection(id, updateHash) {
      var section = findSection(id);
      if (!section) return;
      activate(id);
      if (updateHash && window.history.replaceState) {
        var nextUrl = new URL(window.location.href);
        nextUrl.hash = id;
        window.history.replaceState(window.history.state, '', nextUrl);
      }
      window.requestAnimationFrame(function () {
        var target = mobile.matches ? section.querySelector('summary') : section.querySelector('.pd5-detail__content');
        if (target) target.focus({ preventScroll: true });
        (mobile.matches ? section : detailsArea).scrollIntoView({ behavior: reducedMotion.matches ? 'auto' : 'smooth', block: 'start' });
      });
    }

    product.querySelectorAll('.pd-product-jump').forEach(function (link) {
      link.addEventListener('click', function (event) {
        var id = link.dataset.tab || link.hash.slice(1);
        if (!findSection(id)) return;
        event.preventDefault();
        jumpToSection(id, true);
      });
    });
    window.addEventListener('hashchange', function () {
      var id = window.location.hash.slice(1);
      if (findSection(id)) jumpToSection(id, false);
    });

    var reviews = product.querySelector('#shopify-product-reviews');
    var reviewsSection = sections.find(function (section) { return section.dataset.pd5Detail === 'reviews'; });
    var reviewsTab = tabs.find(function (tab) { return tab.dataset.pd5Tab === 'reviews'; });
    function syncReviews() {
      if (!reviews || !reviewsSection || !reviewsTab) return;
      var hasContent = Boolean(reviews.textContent.trim() || reviews.querySelector('iframe,.spr-review,[data-review-id],[itemprop="review"]'));
      reviewsSection.hidden = !hasContent;
      reviewsTab.hidden = !hasContent;
      if (!hasContent && active === 'reviews') activate('description');
    }
    if (reviews) {
      syncReviews();
      new MutationObserver(syncReviews).observe(reviews, { childList: true, subtree: true, characterData: true });
    }
    applyDetailsMode();
    mobile.addEventListener('change', applyDetailsMode);
    if (findSection(window.location.hash.slice(1))) activate(window.location.hash.slice(1));

    var dataNode = product.querySelector('[data-pd5-variant-data]');
    var data;
    try { data = JSON.parse(dataNode.textContent); } catch (error) { return; }
    var labels = data.labels;
    var variantSelect = product.querySelector('#productSelect');
    var main = product.querySelector('#button-cart');
    var stock = product.querySelector('[data-pd5-stock]');
    var sku = product.querySelector('#pd-product-sku');
    var skuWrap = product.querySelector('[data-pd5-sku-wrap]');
    var accelerated = product.querySelector('[data-pd5-accelerated]');
    var quantity = product.querySelector('#Quantity');
    var sticky = product.querySelector('[data-pd5-sticky]');
    var stickyButton = product.querySelector('#sticky-button-cart');
    var stickyPrice = product.querySelector('[data-pd5-sticky-price]');
    var mainPrice = product.querySelector('#productPrice');
    var selectedId = variantSelect && variantSelect.value ? variantSelect.value : data.initial;
    var pending = false;
    var observedChatRoots = new WeakSet();
    var previewBar = null;
    var previewMutationObserver = new MutationObserver(scheduleSticky);
    var previewResizeObserver = window.ResizeObserver ? new ResizeObserver(scheduleSticky) : null;

    function normaliseQuantity() {
      if (!quantity) return;
      var value = Math.floor(Number(quantity.value));
      if (!Number.isFinite(value) || value < 1) value = 1;
      quantity.value = String(value);
    }

    function selectedVariant() {
      return data.variants.find(function (variant) { return String(variant.id) === String(selectedId); });
    }

    function syncVariant(variantId) {
      selectedId = variantId;
      var variant = selectedVariant();
      var available = Boolean(variant && variant.available);
      if (stock) {
        stock.hidden = available;
        stock.textContent = available ? '' : labels.stock_unavailable;
      }
      if (sku && skuWrap) {
        sku.textContent = variant && variant.sku ? variant.sku : '';
        skuWrap.hidden = !sku.textContent;
      }
      if (accelerated) accelerated.hidden = !available;
      if (main) {
        main.disabled = !available;
        main.classList.toggle('disabled', !available);
        var mainLabel = main.querySelector('#addToCartText');
        var text = available ? labels.add : (variant ? labels.sold_out : labels.unavailable);
        if (mainLabel) mainLabel.textContent = text;
        else main.textContent = text;
      }
      scheduleSticky();
    }

    document.addEventListener('pd5:variant-change', function (event) {
      syncVariant(event.detail.variant ? event.detail.variant.id : null);
    });

    if (variantSelect) variantSelect.addEventListener('change', function () {
      window.setTimeout(function () { syncVariant(variantSelect.value); }, 0);
    });
    if (quantity) quantity.addEventListener('change', normaliseQuantity);
    if (main) main.addEventListener('click', normaliseQuantity, true);

    function isDisplayed(element) {
      return Boolean(element && !element.hidden && element.getClientRects().length && window.getComputedStyle(element).visibility !== 'hidden');
    }

    function overlayOpen() {
      if (document.body.classList.contains('pd-mc-open')) return true;
      var chatOpen = Array.from(document.querySelectorAll('shopify-chat')).some(function (chat) {
        var root = chat.shadowRoot;
        if (!root) return false;
        if (!observedChatRoots.has(root)) {
          new MutationObserver(scheduleSticky).observe(root, { attributes: true, attributeFilter: ['aria-expanded'], childList: true, subtree: true });
          observedChatRoots.add(root);
        }
        var activator = root.querySelector('.activator');
        return Boolean(activator && activator.getAttribute('aria-expanded') === 'true');
      });
      if (chatOpen) return true;
      var candidates = document.querySelectorAll('#pd-mobile-navigation,#pd-mobile-search,.pd-mc,.modal.in,.fancybox-opened,.mfp-wrap,#cart.open .dropdown-menu');
      return Array.from(candidates).some(isDisplayed);
    }

    function keyboardOpen() {
      var activeElement = document.activeElement;
      if (!activeElement || !/^(INPUT|TEXTAREA|SELECT)$/.test(activeElement.tagName)) return false;
      return !window.visualViewport || window.innerHeight - window.visualViewport.height > 120;
    }

    function previewBottomOffset() {
      var wrapper = document.getElementById('PBarNextFrameWrapper');
      var bar = wrapper || document.getElementById('PBarNextFrame');
      if (bar !== previewBar) {
        previewMutationObserver.disconnect();
        if (previewResizeObserver) previewResizeObserver.disconnect();
        previewBar = bar;
        if (bar) {
          previewMutationObserver.observe(bar, { attributes: true, attributeFilter: ['class', 'style', 'hidden', 'height', 'width', 'aria-hidden'] });
          if (previewResizeObserver) previewResizeObserver.observe(bar);
        }
      }
      if (!mobile.matches || !isDisplayed(bar) || bar.getAttribute('aria-hidden') === 'true' || Number(window.getComputedStyle(bar).opacity) === 0) return 0;
      var rect = bar.getBoundingClientRect();
      var viewportHeight = window.innerHeight;
      if (rect.width <= 0 || rect.height <= 0 || rect.bottom <= 0 || rect.top >= viewportHeight || rect.right <= 0 || rect.left >= window.innerWidth) return 0;
      if (!wrapper && rect.height > 200) return 0;
      return Math.ceil(Math.max(0, viewportHeight - Math.max(0, rect.top)));
    }

    function setBodyLength(name, value) {
      var length = value + 'px';
      if (document.body.style.getPropertyValue(name) !== length) document.body.style.setProperty(name, length);
    }

    function updateSticky() {
      pending = false;
      if (!sticky || !main || !stickyButton) return;
      var variant = selectedVariant();
      stickyButton.disabled = main.disabled || !variant || !variant.available;
      var mainText = main.textContent.replace(/\s+/g, ' ').trim();
      if (stickyButton.textContent !== mainText) stickyButton.textContent = mainText;
      var amount = mainPrice && mainPrice.querySelector('.pd-vat-price__amount,.price');
      if (amount && stickyPrice) stickyPrice.textContent = amount.textContent.trim();
      setBodyLength('--pd5-preview-bottom', previewBottomOffset());
      var show = mobile.matches && main.getBoundingClientRect().bottom < 0 && !overlayOpen() && !keyboardOpen();
      if (sticky.hidden === show) sticky.hidden = !show;
      if (document.body.classList.contains('pd5-has-sticky') !== show) document.body.classList.toggle('pd5-has-sticky', show);
      setBodyLength('--pd5-sticky-height', show ? Math.ceil(sticky.getBoundingClientRect().height) : 0);
    }

    function scheduleSticky() {
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(updateSticky);
    }

    if (stickyButton && main) stickyButton.addEventListener('click', function () {
      if (main.disabled || stickyButton.disabled) return;
      normaliseQuantity();
      main.click();
    });
    window.addEventListener('scroll', scheduleSticky, { passive: true });
    window.addEventListener('resize', scheduleSticky, { passive: true });
    document.addEventListener('focusin', scheduleSticky);
    document.addEventListener('focusout', scheduleSticky);
    document.addEventListener('click', function (event) {
      if (event.composedPath().some(function (node) { return node.localName === 'shopify-chat'; })) scheduleSticky();
    }, true);
    if (window.visualViewport) window.visualViewport.addEventListener('resize', scheduleSticky, { passive: true });
    if (sticky && window.ResizeObserver) new ResizeObserver(scheduleSticky).observe(sticky);
    new MutationObserver(function (records) {
      var previewChanged = records.some(function (record) {
        return Array.from(record.addedNodes).concat(Array.from(record.removedNodes)).some(function (node) {
          return node.nodeType === 1 && (node.id === 'PBarNextFrameWrapper' || node.id === 'PBarNextFrame' || node.querySelector('#PBarNextFrameWrapper,#PBarNextFrame'));
        });
      });
      if (previewChanged) scheduleSticky();
    }).observe(document.body, { childList: true, subtree: true });
    if (main) new MutationObserver(scheduleSticky).observe(main, { attributes: true, childList: true, subtree: true, characterData: true });
    if (mainPrice) new MutationObserver(scheduleSticky).observe(mainPrice, { childList: true, subtree: true, characterData: true });
    new MutationObserver(scheduleSticky).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    document.querySelectorAll('#pd-mobile-navigation,#pd-mobile-search,#pd-mobile-cart-modal,#cart').forEach(function (overlay) {
      new MutationObserver(scheduleSticky).observe(overlay, { attributes: true, attributeFilter: ['hidden', 'class', 'aria-hidden', 'style'] });
    });
    syncVariant(selectedId);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
